/**
 * Contact Form Frontend Script
 * Handles form submission and routing logic
 */

(function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        const forms = document.querySelectorAll('.contact-form');
        
        forms.forEach(form => {
            form.addEventListener('submit', handleSubmit);
        });
    }

    async function handleSubmit(e) {
        e.preventDefault();
        
        const form = e.target;
        const formId = form.id;
        const submitButton = form.querySelector('button[type="submit"]');
        const messagesDiv = document.getElementById(formId + '-messages');
        
        // Disable submit button
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';
        
        // Clear previous messages
        if (messagesDiv) {
            messagesDiv.className = 'hidden';
            messagesDiv.innerHTML = '';
        }
        
        // Get form data
        const formData = new FormData(form);
        
        // Validate reCAPTCHA if present
        const recaptchaDiv = document.getElementById(formId + '-recaptcha');
        if (recaptchaDiv && recaptchaDiv.querySelector('.g-recaptcha')) {
            const recaptchaResponse = grecaptcha.getResponse();
            if (!recaptchaResponse) {
                showMessage(messagesDiv, 'Please complete the reCAPTCHA verification.', 'error');
                submitButton.disabled = false;
                submitButton.textContent = submitButton.dataset.originalText || 'Submit';
                return;
            }
            formData.append('recaptcha_response', recaptchaResponse);
        }
        
        try {
            // Submit form via AJAX
            const response = await fetch(form.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });
            
            const data = await response.json();
            
            if (data.success) {
                // Success - route based on form data or show success message
                showMessage(messagesDiv, data.data.message || 'Thank you! Your message has been sent successfully.', 'success');
                
                // Route to different endpoints based on form data
                if (data.data.redirect_url) {
                    setTimeout(() => {
                        window.location.href = data.data.redirect_url;
                    }, 2000);
                } else {
                    // Reset form after success
                    setTimeout(() => {
                        form.reset();
                        if (window.grecaptcha && recaptchaDiv) {
                            grecaptcha.reset();
                        }
                    }, 2000);
                }
            } else {
                // Error
                showMessage(messagesDiv, data.data.message || 'There was an error submitting your form. Please try again.', 'error');
            }
        } catch (error) {
            console.error('Form submission error:', error);
            showMessage(messagesDiv, 'There was an error submitting your form. Please try again.', 'error');
        } finally {
            submitButton.disabled = false;
            submitButton.textContent = submitButton.dataset.originalText || 'Submit';
        }
    }
    
    function showMessage(container, message, type) {
        if (!container) return;
        
        container.className = `p-4 rounded-md mb-4 ${
            type === 'success' 
                ? 'bg-green-100 text-green-800 border border-green-300' 
                : 'bg-red-100 text-red-800 border border-red-300'
        }`;
        container.innerHTML = `<p class="font-medium">${message}</p>`;
        container.classList.remove('hidden');
        
        // Scroll to message
        container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
})();

